import CONFIGS from "@/constants/env";
import { ITagsData } from "@/features/create/interfaces/ITag";
import { IResponseFormat } from "@/interfaces/IHelper";

export const getTags = async (): Promise<IResponseFormat<ITagsData[]>> => {
  try {
    const response = await fetch(`${CONFIGS.API}/tags`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-cache",
    });

    if (!response.ok) {
      console.error("Failed to fetch tags");
      return { status: false, data: [] };
    }

    const data = (await response.json()) as IResponseFormat<ITagsData[]>;
    return { status: true, data: data.data };
  } catch (error) {
    console.error("Error fetching tags:", error);
    return { status: false, data: [] };
  }
};
